/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Createnew1Inputs */

const zh_course_createnew1 = /** @type {(inputs: Course_Createnew1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建课程`)
};

const en_course_createnew1 = /** @type {(inputs: Course_Createnew1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Course`)
};

const es_course_createnew1 = /** @type {(inputs: Course_Createnew1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo Curso`)
};

/**
* | output |
* | --- |
* | "New Course" |
*
* @param {Course_Createnew1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_createnew1 = /** @type {((inputs?: Course_Createnew1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Createnew1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_createnew1(inputs)
	if (locale === "en") return en_course_createnew1(inputs)
	return es_course_createnew1(inputs)
});
export { course_createnew1 as "course_createNew" }